import React from 'react';
import { setTitle } from '../helpers/MetaTag';
import HomeBanner from "../components/sections/HomeBanner";
import HomeHowItWorks from "../components/sections/HomeHowItWorks";
import HomeTestimonial from "../components/sections/HomeTestimonial";
import HomePricing from "../components/sections/HomePricing";


const Home = () => {
  setTitle('Memory Doddle | Home');

  return (
    <>
      <HomeBanner />
      <HomeHowItWorks />
      <HomeTestimonial />
      <HomePricing/>
    </>
  );
};

export default Home;